import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { NavigationService } from '../../shared/services/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class ManageCarrierImportGuard implements CanActivate {

  constructor(private authService: AuthenticationService, private navigation: NavigationService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.navigation.redirectToHomeIfNotAllowed(() => this.authService.canManageCarrierImport());
  }

}
